<template>
  <div v-if="coupon || saleEndDate" class="flex gap-12">
    <RevCoupon
      v-if="coupon"
      :icon="unref(fetchedIcon)"
      :label="coupon.text"
      :tooltip-text="coupon.text"
    />

    <ClientOnly v-if="saleEndDate">
      <RevCounter
        :date="new Date(saleEndDate)"
        :date-labels="{
          weeks: i18n(translations.mobileWeeks),
          days: i18n(translations.mobileDays),
          hours: i18n(translations.mobileHours),
          minutes: i18n(translations.mobileMinutes),
          seconds: i18n(translations.mobileSeconds),
        }"
        date-max-unit="days"
        :mood="theme === 'light' ? 'main' : 'inverse'"
        size="small"
      />

      <template #fallback>
        <RevSkeleton height="24px" shape="line" width="127px" />
      </template>
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
import { type Component, type ShallowRef, ref, unref } from 'vue'

import type { CouponApiProps } from '@backmarket/http-api/src/api-specs-content/shared/coupon'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { RevCounter } from '@ds/components/Counter'
import { RevCoupon } from '@ds/components/Coupon'
import { RevSkeleton } from '@ds/components/Skeleton'

import translations from '../../common/CMS.translations'
import { useIcon } from '../../shared-components/DynamicIcon/helpers/useIcon'

const i18n = useI18n()

const { coupon, saleEndDate, theme } = defineProps<{
  coupon?: Maybe<CouponApiProps>
  saleEndDate?: Maybe<string>
  theme?: Maybe<'light' | 'dark'>
}>()

const fetchedIcon = ref<ShallowRef<Component | undefined>>()

const iconName = coupon?.icon?.icon
if (iconName) {
  const { iconComponent, fetchIconComponent } = useIcon(() => iconName)
  fetchedIcon.value = iconComponent

  await fetchIconComponent()
}
</script>
